import React from "react";
import PropTypes from "prop-types";
import { remixAiUpgradePlan } from "../../utils/canUseAiRemixText";

const UnlockRemixAiPrompt = ({ website, subscription, className = "", style }) => {
  const handleUnlockClick = (event) => {
    event.preventDefault();
    if (typeof window.subscriptions?.upgrade_modal !== "function") {
      return;
    }

    window.subscriptions.upgrade_modal(
      event,
      false,
      "get weekly AI funnel analysis reports and experiment recommendations.",
      remixAiUpgradePlan({ subscription, website }),
      "Triggered feature CTA – Remix AI",
      false,
      "x3rs6cvrwi"
    );
  };

  return (
    <p className={`text-xl mb-0 light ${className}`.trim()} style={style}>
      Unlock Remix AI to get weekly AI funnel analysis reports and experiment
      recommendations.{" "}
      <a href="#" onClick={handleUnlockClick} className="text-xl">
        Unlock Remix AI →
      </a>
    </p>
  );
};

UnlockRemixAiPrompt.propTypes = {
  website: PropTypes.object,
  subscription: PropTypes.object,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default UnlockRemixAiPrompt;
